// import external dependencies
import 'jquery'

// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_custom-row-margin.js'; import './autoload/_custom-space.js'; import './autoload/_matchHeight.js' // eslint-disable-line

// import vc-elements javascript files
import '../vc_elements/_new/main.js'; import '../vc_elements/3d_diagramm/main.js'; import '../vc_elements/animated_lines/main.js'; import '../vc_elements/button/main.js'; import '../vc_elements/cases_list/main.js'; import '../vc_elements/child_pages/main.js'; import '../vc_elements/cloud_scheme/main.js'; import '../vc_elements/colocation_scheme/main.js'; import '../vc_elements/complex_accordion/main.js'; import '../vc_elements/contact_info_large/main.js'; import '../vc_elements/counter/main.js'; import '../vc_elements/data_centers/main.js'; import '../vc_elements/diagramm_warum/main.js'; import '../vc_elements/parallax_text/main.js'; import '../vc_elements/posts/main.js'; import '../vc_elements/round_diagramm/main.js'; import '../vc_elements/template_element/main.js'; import '../vc_elements/timeline/main.js'; import '../vc_elements/typing_text/main.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
